export const PATH_HOME = "/";
export const PATH_PREMIUM_OFFERS_SHOP = `${PATH_HOME}premium-offers/`;

export const PATH_HOME_TERMS = `${PATH_HOME}terms/`;
export const PATH_TERMS_COMPLIMENTARY_NIGHT = `${PATH_HOME_TERMS}complimentary-night/`;
